import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { sendOtp, verifyOtp,signOutUser, exchangeToken } from "./auth_service";
import { initAuthObserver } from "./auth_service";
import { passwordLogin, googleSignIn, appleSignIn, registerWithEmail, forgotPassword, sendVerificationOtp, verifyPhoneNumber, checkProfile } from "./auth_service";

const initialState = {
    isLoading: false,
    isClick:false,
    status: 'idle',
    verificationId: null,
    accessToken: null,
    phoneNumber: '',
    otp: null,
    error: null,
    user: null,
  
    statusVerify: 'idle',
    isLoadingVerify: false,
    errorVerify: null,

    statusLogout:'idle',
    
    // Password login
    statusPasswordLogin: 'idle',
    errorPasswordLogin: null,
    
    // Social auth
    statusGoogleLogin: 'idle',
    statusAppleLogin: 'idle',
    errorSocialLogin: null,
    
    // Email registration
    statusEmailRegister: 'idle',
    errorEmailRegister: null,
    
    // Forgot password
    statusForgotPassword: 'idle',
    errorForgotPassword: null,
    forgotPasswordSuccess: false,
    
    // Phone verification
    statusPhoneVerification: 'idle',
    errorPhoneVerification: null,
    phoneVerificationOtpSent: false,
    
    // Profile check
    needsProfile: false,
};

export  const prefix = '+'

export const  sendOtpRequest = createAsyncThunk("type/sendOtpRequest", async (data) => {
    data.phoneNumberInput = prefix + data.phoneNumberInput; // add plus in react js
    const verificationId = await sendOtp(data.phoneNumberInput); // Assuming sendOtp is an async function

    return verificationId;
});

export const  verifyOtpAsync = createAsyncThunk("type/verifyOtpAsync", async (data) => {
  const accessToken = await verifyOtp(data.verificationId, data.otpInput); // Assuming verifyOtp is an async function

  return accessToken;
});

export const  exchangeTokenAsync = createAsyncThunk("type/exchangeToken", async ({dynamicState,auth}) => {
  const token =await exchangeToken({dynamicState,auth})

  return token;
});

export const  logoutRequest = createAsyncThunk("type/logoutRequest", async () => {
    const logout =await signOutUser();

    return logout;
});

export const passwordLoginAsync = createAsyncThunk("auth/passwordLogin", async ({ mobileOrEmail, password }) => {
  const user = await passwordLogin(mobileOrEmail, password);
  return user;
});

export const googleSignInAsync = createAsyncThunk("auth/googleSignIn", async () => {
  const user = await googleSignIn();
  return user; // may be null if user cancelled
});

export const appleSignInAsync = createAsyncThunk("auth/appleSignIn", async () => {
  const user = await appleSignIn();
  return user; // may be null if user cancelled
});

export const registerWithEmailAsync = createAsyncThunk("auth/registerWithEmail", async ({ email, password, nickname }) => {
  const user = await registerWithEmail(email, password, nickname);
  return user;
});

export const forgotPasswordAsync = createAsyncThunk("auth/forgotPassword", async ({ email }) => {
  await forgotPassword(email);
  return true;
});

export const sendVerificationOtpAsync = createAsyncThunk("auth/sendVerificationOtp", async ({ mobileWithPlus }) => {
  await sendVerificationOtp(mobileWithPlus);
  return true;
});

export const verifyPhoneNumberAsync = createAsyncThunk("auth/verifyPhoneNumber", async ({ mobileWithPlus, otp }) => {
  const result = await verifyPhoneNumber(mobileWithPlus, otp);
  return result;
});

export const checkProfileAsync = createAsyncThunk("auth/checkProfile", async () => {
  const hasProfile = await checkProfile();
  return hasProfile;
});

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser:  (state, action) => {
            state.user = action.payload.user;
            state.accessToken =  action.payload.accessToken;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload.isLoading;
        },
        setStatus: (state, action) => {
          state.status = action.payload.status;
        },
        setStatusVerify: (state,action) => {
          state.statusVerify = action.payload.statusVerify;
        },
        setError: (state,action) => {
          state.error = action.payload.error;
        },
        setErrorVerify: (state,action) => {
          state.errorVerify = action.payload.errorVerify;
        },setIsClick :(state,action) => {
          state.isClick = action.payload;
        },setAccessToken :(state,action) => {
          state.accessToken = action.payload;
        },
        clearSocialError: (state) => {
          state.errorSocialLogin = null;
          state.errorPasswordLogin = null;
          state.errorEmailRegister = null;
          state.errorForgotPassword = null;
          state.errorPhoneVerification = null;
        },
        setNeedsProfile: (state, action) => {
          state.needsProfile = action.payload;
        },
        resetForgotPassword: (state) => {
          state.statusForgotPassword = 'idle';
          state.errorForgotPassword = null;
          state.forgotPasswordSuccess = false;
        },
        resetPhoneVerification: (state) => {
          state.statusPhoneVerification = 'idle';
          state.errorPhoneVerification = null;
          state.phoneVerificationOtpSent = false;
        }
    },
    extraReducers: builder => {
        builder
          .addCase(sendOtpRequest.pending, (state, action) => {
            state.status = 'loading';
            state.isClick = true;
            state.error = null;
            state.errorVerify = null;
          })
          .addCase(sendOtpRequest.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.statusLogout = 'idle';
            state.error = null;
            state.errorVerify = null;
            state.isClick = false;
            state.verificationId=action.payload
          })
          .addCase(sendOtpRequest.rejected, (state, action) => {
            state.status = 'failed';
            state.isClick = false;
            state.error = action.error.message;
            state.errorVerify = null;
            console.log("Error in sendOtpRequest" + action.error.message);
          }).addCase(verifyOtpAsync.pending, (state, action) => {
            state.statusVerify = 'loading';
            state.isClick = true;
            state.errorVerify = null;
          })
          .addCase(verifyOtpAsync.fulfilled, (state, action) => {
            state.statusVerify = 'succeeded';
            state.isClick = false;
            state.errorVerify = null;
            state.verificationId=action.payload.verificationId;
            state.otp=action.payload.otp;
          })
          .addCase(verifyOtpAsync.rejected, (state, action) => {
            state.statusVerify = 'failed';
            state.isClick = false;
            state.errorVerify = action.error.message;
            console.log("Error in verifyOtpAsync" + action.error.message);
          })
          .addCase(logoutRequest.pending, (state, action) => {
            state.statusLogout = 'loading';
            state.isClick = true;
            state.error = null;
          })
          .addCase(logoutRequest.fulfilled, (state, action) => {
            state.statusLogout = 'succeeded';
            state.status = 'idle';
            state.isClick = false;
            state.error = null;
            state.user = null;
            state.accessToken=null;
            state.isLogout = true;
          })
          .addCase(logoutRequest.rejected, (state, action) => {
            state.statusLogout = 'failed';
            state.isClick = false;
            state.error = action.error.message;
            console.log("Error in logoutRequest" +action.error.message);
          })
          // Password login
          .addCase(passwordLoginAsync.pending, (state) => {
            state.statusPasswordLogin = 'loading';
            state.errorPasswordLogin = null;
            state.isClick = true;
          })
          .addCase(passwordLoginAsync.fulfilled, (state, action) => {
            state.statusPasswordLogin = 'succeeded';
            state.errorPasswordLogin = null;
            state.isClick = false;
          })
          .addCase(passwordLoginAsync.rejected, (state, action) => {
            state.statusPasswordLogin = 'failed';
            state.errorPasswordLogin = action.error.message;
            state.isClick = false;
          })
          // Google sign-in
          .addCase(googleSignInAsync.pending, (state) => {
            state.statusGoogleLogin = 'loading';
            state.errorSocialLogin = null;
          })
          .addCase(googleSignInAsync.fulfilled, (state, action) => {
            state.statusGoogleLogin = 'succeeded';
            state.errorSocialLogin = null;
            // user will be set by initAuthObserver
          })
          .addCase(googleSignInAsync.rejected, (state, action) => {
            state.statusGoogleLogin = 'failed';
            state.errorSocialLogin = action.error.message;
          })
          // Apple sign-in
          .addCase(appleSignInAsync.pending, (state) => {
            state.statusAppleLogin = 'loading';
            state.errorSocialLogin = null;
          })
          .addCase(appleSignInAsync.fulfilled, (state, action) => {
            state.statusAppleLogin = 'succeeded';
            state.errorSocialLogin = null;
          })
          .addCase(appleSignInAsync.rejected, (state, action) => {
            state.statusAppleLogin = 'failed';
            state.errorSocialLogin = action.error.message;
          })
          // Email registration
          .addCase(registerWithEmailAsync.pending, (state) => {
            state.statusEmailRegister = 'loading';
            state.errorEmailRegister = null;
            state.isClick = true;
          })
          .addCase(registerWithEmailAsync.fulfilled, (state) => {
            state.statusEmailRegister = 'succeeded';
            state.errorEmailRegister = null;
            state.isClick = false;
          })
          .addCase(registerWithEmailAsync.rejected, (state, action) => {
            state.statusEmailRegister = 'failed';
            state.errorEmailRegister = action.error.message;
            state.isClick = false;
          })
          // Forgot password
          .addCase(forgotPasswordAsync.pending, (state) => {
            state.statusForgotPassword = 'loading';
            state.errorForgotPassword = null;
            state.forgotPasswordSuccess = false;
          })
          .addCase(forgotPasswordAsync.fulfilled, (state) => {
            state.statusForgotPassword = 'succeeded';
            state.forgotPasswordSuccess = true;
          })
          .addCase(forgotPasswordAsync.rejected, (state, action) => {
            state.statusForgotPassword = 'failed';
            state.errorForgotPassword = action.error.message;
          })
          // Phone verification OTP send
          .addCase(sendVerificationOtpAsync.pending, (state) => {
            state.statusPhoneVerification = 'loading';
            state.errorPhoneVerification = null;
          })
          .addCase(sendVerificationOtpAsync.fulfilled, (state) => {
            state.statusPhoneVerification = 'idle';
            state.phoneVerificationOtpSent = true;
          })
          .addCase(sendVerificationOtpAsync.rejected, (state, action) => {
            state.statusPhoneVerification = 'failed';
            state.errorPhoneVerification = action.error.message;
          })
          // Phone verification verify
          .addCase(verifyPhoneNumberAsync.pending, (state) => {
            state.statusPhoneVerification = 'loading';
            state.errorPhoneVerification = null;
          })
          .addCase(verifyPhoneNumberAsync.fulfilled, (state) => {
            state.statusPhoneVerification = 'succeeded';
            state.phoneVerificationOtpSent = false;
          })
          .addCase(verifyPhoneNumberAsync.rejected, (state, action) => {
            state.statusPhoneVerification = 'failed';
            state.errorPhoneVerification = action.error.message;
          })
          // Check profile
          .addCase(checkProfileAsync.fulfilled, (state, action) => {
            state.needsProfile = !action.payload;
          })
      }
});

export const initAuthObserverAsync =  () => (dispatch) => {
    dispatch(setLoading({ isLoading: true }));
    initAuthObserver(async (user) => {
        if (user) {
            await user.getIdToken() 
            .then(function(idToken) {
              dispatch(setUser({ user: user,accessToken:idToken }));
            }).catch(function(error) {
               console.log("error : " + error)
            });
        }else{
            dispatch(setUser({ user: null,accessToken:null }));
        }
        dispatch(setLoading({ isLoading: false }));
    });

};




export const {  verifyOtpSuccess,setUser,setLoading,setLogOut,setStatus,
  setStatusVerify,setError,setErrorVerify,setIsClick,setAccessToken,
  clearSocialError, setNeedsProfile, resetForgotPassword, resetPhoneVerification } = authSlice.actions;
export default authSlice.reducer;
